import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { GetAChannel, GetAChannelContext } from "./stores/GetAChannel";
import { Stack } from "@mantine/core";
import NetworkSelector from "./components/get_a_channel/NetworkSelector";
import ConnectToNode from "./components/get_a_channel/ConnectToNode";
import GetInfo from "./components/get_a_channel/GetInfo";
import CreateOrderForm from "./components/get_a_channel/CreateOrderForm";
import PayInvoice from "./components/get_a_channel/PayInvoice";
import OrderStatus from "./components/get_a_channel/OrderStatus";
import {
  Paper,
  Title,
  Textarea,
  CopyButton,
  Image,
  Button,
  Text,
} from "@mantine/core";
const GetAChannelContainer: React.FC = observer(() => {
  const getAChannel = useContext<GetAChannel>(GetAChannelContext);

  useEffect(() => {
    getAChannel.hydrateDataFromPage();
  }, []);

  return (
    <Stack>
      <Paper withBorder p="md">
        <Image
          mb="md"
          h={150}
          w="auto"
          fit="contain"
          radius="md"
          src="https://d3u5cu1kr5hxm.cloudfront.net/images/megalith-logo-400.webp"
          style={{ verticalAlign: "middle", marginRight: "10px" }}
        />
        <Title order={2}>Get A Megalith LSP Channel</Title>
 <Text>
         Megalith LSP (Lightning Service Provider) is a service that provides inbound channels to
Lightning Network nodes.  </Text>
<Text mt="sm">
  In continuous operation since 2024, Megalith LSP is one of the biggest and most active LSPs currently operating on the Lightning Network.
    </Text>

        <Text mt="sm">
          Use this page to instantly get an inbound channel from Megalith LSP.
          This will allow your node to reliably receive payments on the
          Lightning Network.
        </Text>
      </Paper>
      {!getAChannel.selectedNetwork && (
        <Paper withBorder p="md">
          <NetworkSelector getAChannel={getAChannel} />
        </Paper>
      )}
      {getAChannel.selectedNetwork &&
        !getAChannel.userHasConfirmedIsConnected && (
          <ConnectToNode getAChannel={getAChannel} />
        )}
      {getAChannel.userHasConfirmedIsConnected &&
        getAChannel.getInfoDataHasLoaded == undefined && (
          <GetInfo getAChannel={getAChannel} />
        )}
      {getAChannel.getInfoDataHasLoaded && (
        <CreateOrderForm getAChannel={getAChannel} />
      )}
      {getAChannel.orderData && <PayInvoice getAChannel={getAChannel} />}
    </Stack>
  );
});

export default GetAChannelContainer;
